var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{key:_vm.key,staticClass:"input--no-arrows",attrs:{"value":_vm.value,"name":_vm.name,"prefix":`${_vm.$tc('day', _vm.value)}:`,"background-color":"white","data-cy":"days-selector","type":"number","single-line":"","outlined":""},on:{"input":_vm.inputDay}})
}
var staticRenderFns = []

export { render, staticRenderFns }